<template>
  <div v-if="isProcessing" id="overlay" class="flex items-center justify-center">
    <div class="w-16 h-16 spinner" />
    <div class="overlay-container" v-if="showMessage">
      <p class="message">{{message1}}<br>{{message2}}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isProcessing: {
      type: Boolean,
      default: false
    },

    showMessage: {
      type: Boolean,
      default: false
    },

    message1: {
      type: String,
      default: ""
    },

    message2: {
      type: String,
      default: ""
    }
  }
}
</script>

<style scoped>
#overlay {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}

.overlay-container {
  width: 100%;
  margin: 0 20px;
  max-width: 335px;
  background-color: #ffffff;
  padding: 20px;
  border-radius: 10px;
  position: relative;
}

.overlay-container p.message {
  font-size: 16px;
  line-height: 24px;
  font-weight: 600;
  text-align: center;
}

@keyframes spinner {
  to {transform: rotate(360deg);}
}

.spinner:before {
  content: '';
  box-sizing: border-box;
  position: absolute;
  top: 50%;
  left: 50%;
  width: 3rem;
  height: 3rem;
  margin-top: -150px;
  margin-left: -25px;
  border-radius: 50%;
  border-top: 3px solid #FA3B4E;
  border-right: 3px solid transparent;
  animation: spinner .6s linear infinite;
}
</style>
